module.exports = __webpack_public_path__ + "img/small-9.5e32da8b.webp";